import http from '@/lib/http'
import { useQuery } from '@tanstack/react-query'

export type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'

type DailyCutoff = {
  cutoff_time: string
}

export type TotalMedicationRequestResponse = {
  total: number
  beforeCutOff: number
  totalInvestigations?: number
  cutoffTimes: Partial<Record<DayOfWeek, DailyCutoff>>
}

/**
 * Fetch total medication request metadata including daily cutoff times.
 */
export const useTotalMedicationRequests = () => {
  return useQuery<TotalMedicationRequestResponse>({
    queryKey: ['totalMedicationRequests'],
    queryFn: async () =>
      (await http.get('/dashboard-totals', {
        timeout: (http.defaults.timeout ?? 10000) * 6
      })) as TotalMedicationRequestResponse,
    refetchInterval: 30000
  })
}
